import { ListExternalContactsRequestSchema, ListExternalContactsResponseSchema } from './list-external-contacts.schema';
/**
 * List External Contacts Endpoint Contract
 * Retrieves all external contacts in the organization
 */ export const listExternalContactsContract = {
    method: 'GET',
    path: '/api/v2/external-contact',
    description: 'Retrieve all external contacts in the organization',
    requestSchema: ListExternalContactsRequestSchema,
    responseSchema: ListExternalContactsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-external-contacts.contract.js.map